import React, { useState, useEffect, useRef } from 'react'
import Header from '../../layout/header'
import Footer from '../../layout/footer'
import Banner from './banner'
import List from './list'
import MiddleBanner from './middle-banner'
import { useSelector, useDispatch } from "react-redux";
// import { setGetCloudBucketData } from '../../redux/reducers/getCloudBucketSlice';
import { apiCallingPost } from '../../api/services';
import ListShowAll from './list-show-all'
import useSearch from '../../hooks/useSearch';

function Home() {
  const dispatch = useDispatch();
  // const { getCloudBucketData } = useSelector((state) => state.getCloudBucketDetails);
  const { showMoreTag, fileType } = useSelector((state) => state.commonData);
  const { isAuthenticated } = useSelector((state) => state.authentication);
  const { userData } = useSelector((state) => state.masterData);

  const [destinationList, setDestinationList] = useState([]);
  const [destListTCount, setDestListTCount] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [videoListFlag, setVideoListFlag] = useState(false);
  useSearch({ setVideoListFlag });
  const [loading, setLoading] = useState(false);
  const [getCloudBucketData, setGetCloudBucketData] = useState([]);
  const [itemsCountPerPage, setItemsCountPerPage] = useState(15);
  const [activePage, setActivePage] = useState(1);
  const [firstId, setFirstId] = useState(null);
  const [lastId, setLastId] = useState(null);
  const [hasNext, setHasNext] = useState(false);
  const [hasPrevious, setHasPrevious] = useState(false);

  // ---------------------
  // Scroll lock helpers
  // ---------------------
  const lockScroll = () => {
    document.body.style.overflow = 'hidden';
    document.body.classList.add('scroll-locked');
  };

  const unlockScroll = () => {
    document.body.style.overflow = '';
    document.body.classList.remove('scroll-locked');
  };

  // ---------------------
  // Initial Data Loading
  // ---------------------
  useEffect(() => {
    bucketDetails();
  }, []);

  useEffect(() => {
    setActivePage(1);
    getData({ direction: "first", cursorId: null });
  }, [fileType, isAuthenticated, userData, itemsCountPerPage]);

  // ---------------------
  // Window Scroll trigger at 75%
  // ---------------------
  // useEffect(() => {
  //   let timeout;
  //   let cooldown = false;

  //   const handleScroll = () => {
  //     clearTimeout(timeout);
  //     timeout = setTimeout(async () => {
  //       const scrollTop = window.scrollY || window.pageYOffset;
  //       const windowHeight = window.innerHeight;
  //       const docHeight = document.documentElement.scrollHeight;
  //       const scrolledRatio = (scrollTop + windowHeight) / docHeight;

  //       if (
  //         scrolledRatio >= 0.75 &&
  //         hasMore &&
  //         !isFetchingRef.current &&
  //         !cooldown &&
  //         lastFetchedOffset.current !== offset
  //       ) {
  //         isFetchingRef.current = true;
  //         cooldown = true;
  //         lastFetchedOffset.current = offset;

  //         const nextOffset = offset + itemsCountPerPage;
  //         // console.log("📡 Fetching next batch at 75% scroll, offset:", nextOffset);

  //         try {
  //           lockScroll();
  //           await getData(nextOffset, itemsCountPerPage, true);
  //           setOffset(nextOffset);
  //         } catch (err) {
  //           console.error("Error fetching next batch:", err);
  //         } finally {
  //           unlockScroll();
  //           isFetchingRef.current = false;
  //           setTimeout(() => {
  //             cooldown = false;
  //           }, 1200);
  //         }
  //       }
  //     }, 150);
  //   };

  //   window.addEventListener('scroll', handleScroll, { passive: true });

  //   return () => {
  //     clearTimeout(timeout);
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, [offset, max, hasMore]);

  // ---------------------
  // Config Data
  // ---------------------
  const bucketDetails = async () => {
    try {
      const { data } = await apiCallingPost("api/common/getConfigData", {});
      if (data.success === "1") {
        setGetCloudBucketData(data.result);
      }
    } catch (err) {
      console.error("Error fetching bucket details:", err);
    }
  };
  // ---------------------
  // Fetch Video Data (cursor-based pagination)
  // ---------------------
  const getData = async (paginationParams = { direction: "first", cursorId: null }, isLoadMore = false) => {
    const { direction = "first", cursorId = null } = paginationParams;
    if ((direction === "next" || direction === "previous") && (cursorId == null || cursorId === "")) {
      return;
    }
    setLoading(true);
    let postData = {};
    let url = "";
    const paginationPayload = {
      limit: Number(itemsCountPerPage),
      direction,
      cursorId: cursorId ?? null
    };

    if (isAuthenticated && userData?.roleDisplayName !== "User") {
      postData = {
        ...paginationPayload,
        userId: "",
        videoName: "",
        fromDate: "",
        toDate: "",
        videoApprovedStatus: "",
        file_type_id: fileType,
        is_processed: "true",
        is_upload_request: ""
      };
      url = "api/video/videoList";
    } else {
      postData = {
        ...paginationPayload,
        videoNameSearch: "",
        userNameSearch: "",
        fromDate: "",
        toDate: "",
        user_id: userData?.roleDisplayName === "User" ? userData?.userId : "",
        file_type_id: fileType,
        is_processed: "true"
      };
      url = "api/video/approvedVideoList";
    }

    try {
      // console.log(".....postData......",postData);
      
      const { data } = await apiCallingPost(url, postData);
      // console.log(".....data......",data);

      if (data.success === "1") {
        let destinationListArray =
          isAuthenticated && userData?.roleDisplayName !== "User"
            ? data.dataArray
            : data.result;

        setDestinationList((prev) =>
          isLoadMore ? [...prev, ...destinationListArray] : destinationListArray
        );
        setDestListTCount(data.totalCount || 0);
        setFirstId(data.first_id ?? null);
        setLastId(data.last_id ?? null);

        if (direction === "last") {
          setHasNext(false);
          setHasPrevious(true);
          if (data.totalCount) {
            setActivePage(Math.ceil(Number(data.totalCount) / itemsCountPerPage));
          }
        } else if (direction === "first") {
          setHasPrevious(false);
          setHasNext(!!data.hasNext);
          setActivePage(1);
        } else {
          setHasNext(!!data.hasNext);
          setHasPrevious(!!data.hasPrevious);
          if (direction === "next") setActivePage((p) => p + 1);
          else if (direction === "previous") setActivePage((p) => Math.max(1, p - 1));
        }
      } else {
        setDestinationList([]);
        setDestListTCount(0);
        setFirstId(null);
        setLastId(null);
        setHasNext(false);
        setHasPrevious(false);
      }
    } catch (err) {
      console.error("❌ Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleTriggerSearch = () => {
    setShowMore(true);
  };

  // ---------------------
  // Render
  // ---------------------
  return (
    <div
      className={`home-wrapper main-wrapper ${
        isAuthenticated && userData?.userDisplayName !== "User"
          ? "main-wrapper-cms"
          : ""
      }`}
    >
      <Header />
      <Banner
        isAuthenticated={isAuthenticated}
        setShowMore={setShowMore}
        showMore={showMore}
        videoListFlag={videoListFlag}
        setVideoListFlag={setVideoListFlag}
        triggerSearch={handleTriggerSearch}
      />

      <div className={videoListFlag ? "filter-blur" : ""}>
        {!showMoreTag ? (
          <>
            {((!isAuthenticated && destListTCount > 0) ||
              (isAuthenticated &&
                ((userData?.roleDisplayName === "User" && destListTCount > 0) ||
                  userData?.roleDisplayName === "Admin" ||
                  userData?.roleDisplayName === "Super_admin" ||
                  userData?.roleDisplayName === "APPROVER"))) && (
              <List
                key={`list-${fileType}-${isAuthenticated}`}
                fileType={fileType}
                isAuthenticated={isAuthenticated}
                userData={userData}
                destinationList={destinationList}
                setDestinationList={setDestinationList}
                destListTCount={destListTCount}
                getData={getData}
                getCloudBucketData={getCloudBucketData}
                loading={loading}
                itemsCountPerPage={itemsCountPerPage}
                setItemsCountPerPage={setItemsCountPerPage}
                activePage={activePage}
                firstId={firstId}
                lastId={lastId}
                hasNext={hasNext}
                hasPrevious={hasPrevious}
              />
            )}
          </>
        ) : (
          <ListShowAll
            isAuthenticated={isAuthenticated}
            userData={userData}
            triggerSearch={handleTriggerSearch}
            showMore={showMore}
          />
        )}
        <Footer />
      </div>
    </div>
  );
}

export default Home;
